const tag = ({ tag, index, length }) => {
    return (
        <span>
            #{tag}
            {index === length - 1 ? "" : ", "}
        </span>
    );
};

export default tag;
